module.exports = __webpack_public_path__ + "img/2024517-icon3.ce94178.svg";